export interface IAuthenticationGateway{
    login( redirectState:string):void;
    logout():void;
    parseUrlHashFragment():ng.IPromise<any>;
    refreshToken():ng.IPromise<any>;
}

export class AuthenticationGateway implements IAuthenticationGateway{

    static $inject = ['angularAuth0', '$q'];

    constructor( private angularAuth0: any,
        private $q: ng.IQService
        ) {

          
    }

    public login(redirectState): void {
        this.angularAuth0.authorize({state: redirectState});
    }    
    
    public logout(): void {
        //TODO: current solution doesnt do this, but we should probably be explicitly revoking a token when user explicitly logs out instead of just "losing a reference" to a valid token
    }

    public parseUrlHashFragment(): ng.IPromise<any> {
       
        const dependency = this.$q.defer();

        this.angularAuth0.parseHash(function(err, jwt) {

            if(err){
                console.log(err)
                dependency.reject(err);
            }
            
            dependency.resolve(jwt);
          });

        return dependency.promise;

    }

    public refreshToken(): ng.IPromise<any> {
        const dependency = this.$q.defer();

        this.angularAuth0.checkSession({},         
          function(err, jwt) {
            if(err){
                console.log(err)
                dependency.reject(err);
            }
            
            dependency.resolve(jwt);
          }
        );

        return dependency.promise;
      }
}